import { Fragment, useEffect, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

const languages = [
  {
    LanguageName: "ABAP",
    LanguageCode: "abap",
    CompilerCode: "Not Supported",
    Extension: ".abap",
  },
  {
    LanguageName: "Action Script",
    LanguageCode: "actionscript",
    CompilerCode: "Not Supported",
    Extension: ".as",
  },
  {
    LanguageName: "ADA",
    LanguageCode: "ada",
    CompilerCode: "ada",
    Extension: ".ada",
  },
  {
    LanguageName: "Arduino",
    LanguageCode: "arduino",
    CompilerCode: "Not Supported",
    Extension: ".ino",
  },
  {
    LanguageName: "AutoIt",
    LanguageCode: "autoit",
    CompilerCode: "Not Supported",
    Extension: ".au3",
  },
  { LanguageName: "C", LanguageCode: "c", CompilerCode: "c", Extension: ".c" },
  {
    LanguageName: "Clojure",
    LanguageCode: "clojure",
    CompilerCode: "clojure",
    Extension: ".clj",
  },
  {
    LanguageName: "CS",
    LanguageCode: "cs",
    CompilerCode: "csharp",
    Extension: ".cs",
  },
  {
    LanguageName: "C++",
    LanguageCode: "cpp",
    CompilerCode: "cpp",
    Extension: ".cpp",
  },
  {
    LanguageName: "Coffee Script",
    LanguageCode: "coffeescript",
    CompilerCode: "coffeescript",
    Extension: ".coffee",
  },
  {
    LanguageName: "C Sharp",
    LanguageCode: "csharp",
    CompilerCode: "csharp",
    Extension: ".cs",
  },
  {
    LanguageName: "CSS",
    LanguageCode: "css",
    CompilerCode: "Not Supported",
    Extension: ".css",
  },
  {
    LanguageName: "Cuda",
    LanguageCode: "cuda",
    CompilerCode: "Not Supported",
    Extension: ".cu",
  },
  { LanguageName: "D", LanguageCode: "d", CompilerCode: "d", Extension: ".d" },
  {
    LanguageName: "Dart",
    LanguageCode: "dart",
    CompilerCode: "dart",
    Extension: ".dart",
  },
  {
    LanguageName: "Delphi",
    LanguageCode: "delphi",
    CompilerCode: "Not Supported",
    Extension: ".pas",
  },
  {
    LanguageName: "Elixir",
    LanguageCode: "elixir",
    CompilerCode: "elixir",
    Extension: ".ex",
  },
  {
    LanguageName: "ELM",
    LanguageCode: "elm",
    CompilerCode: "Not Supported",
    Extension: ".elm",
  },
  {
    LanguageName: "ErLang",
    LanguageCode: "erlang",
    CompilerCode: "erlang",
    Extension: ".erl",
  },
  {
    LanguageName: "Fortran",
    LanguageCode: "fortran",
    CompilerCode: "fortran",
    Extension: ".f",
  },
  {
    LanguageName: "FoxPro",
    LanguageCode: "foxpro",
    CompilerCode: "Not Supported",
    Extension: ".prg",
  },
  {
    LanguageName: "F#",
    LanguageCode: "fsharp",
    CompilerCode: "fsharp",
    Extension: ".fs",
  },
  {
    LanguageName: "GO",
    LanguageCode: "go",
    CompilerCode: "go",
    Extension: ".go",
  },
  {
    LanguageName: "Graphql",
    LanguageCode: "graphql",
    CompilerCode: "Not Supported",
    Extension: ".graphql",
  },
  {
    LanguageName: "GQL",
    LanguageCode: "gql",
    CompilerCode: "Not Supported",
    Extension: ".gql",
  },
  {
    LanguageName: "Groovy",
    LanguageCode: "groovy",
    CompilerCode: "groovy",
    Extension: ".groovy",
  },
  {
    LanguageName: "Haskell",
    LanguageCode: "haskell",
    CompilerCode: "haskell",
    Extension: ".hs",
  },
  {
    LanguageName: "Haxe",
    LanguageCode: "haxe",
    CompilerCode: "Not Supported",
    Extension: ".hx",
  },
  {
    LanguageName: "HTML",
    LanguageCode: "html",
    CompilerCode: "Not Supported",
    Extension: ".html",
  },
  {
    LanguageName: "Java",
    LanguageCode: "java",
    CompilerCode: "java",
    Extension: ".java",
  },
  {
    LanguageName: "Javascript",
    LanguageCode: "javascript",
    CompilerCode: "nodejs",
    Extension: ".js",
  },
  {
    LanguageName: "JSON",
    LanguageCode: "json",
    CompilerCode: "Not Supported",
    Extension: ".json",
  },
  {
    LanguageName: "Julia",
    LanguageCode: "julia",
    CompilerCode: "Not Supported",
    Extension: ".jl",
  },
  {
    LanguageName: "JSX",
    LanguageCode: "jsx",
    CompilerCode: "nodejs",
    Extension: ".jsx",
  },
  {
    LanguageName: "Node. js",
    LanguageCode: "js",
    CompilerCode: "nodejs",
    Extension: ".js",
  },
  {
    LanguageName: "Kotlin",
    LanguageCode: "kotlin",
    CompilerCode: "kotlin",
    Extension: ".kt",
  },
  {
    LanguageName: "Latex",
    LanguageCode: "latex",
    CompilerCode: "Not Supported",
    Extension: ".tex",
  },
  {
    LanguageName: "Lsip",
    LanguageCode: "lisp",
    CompilerCode: "Not Supported",
    Extension: ".lisp",
  },
  {
    LanguageName: "Livescript",
    LanguageCode: "livescript",
    CompilerCode: "Not Supported",
    Extension: ".ls",
  },
  {
    LanguageName: "LUA",
    LanguageCode: "lua",
    CompilerCode: "lua",
    Extension: ".lua",
  },
  {
    LanguageName: "Mathematica",
    LanguageCode: "mathematica",
    CompilerCode: "Not Supported",
    Extension: ".nb",
  },
  {
    LanguageName: "Makefile",
    LanguageCode: "makefile",
    CompilerCode: "Not Supported",
    Extension: ".mk",
  },
  {
    LanguageName: "Matlab",
    LanguageCode: "matlab",
    CompilerCode: "Not Supported",
    Extension: ".m",
  },
  {
    LanguageName: "Objective C",
    LanguageCode: "objectivec",
    CompilerCode: "objectivec",
    Extension: ".m",
  },
  {
    LanguageName: "Objective",
    LanguageCode: "objective",
    CompilerCode: "Not Supported",
    Extension: ".obj",
  },
  {
    LanguageName: "Object Pascal",
    LanguageCode: "objectpascal",
    CompilerCode: "Not Supported",
    Extension: ".pas",
  },
  {
    LanguageName: "Ocmal",
    LanguageCode: "ocaml",
    CompilerCode: "ocaml",
    Extension: ".ml",
  },
  {
    LanguageName: "Octave",
    LanguageCode: "octave",
    CompilerCode: "octave",
    Extension: ".m",
  },
  {
    LanguageName: "PERL",
    LanguageCode: "perl",
    CompilerCode: "perl",
    Extension: ".pl",
  },
  {
    LanguageName: "PHP",
    LanguageCode: "php",
    CompilerCode: "php",
    Extension: ".php",
  },
  {
    LanguageName: "PowerShell",
    LanguageCode: "powershell",
    CompilerCode: "Not Supported",
    Extension: ".ps1",
  },
  {
    LanguageName: "Prolog",
    LanguageCode: "prolog",
    CompilerCode: "Not Supported",
    Extension: ".pl",
  },
  {
    LanguageName: "Puppet",
    LanguageCode: "puppet",
    CompilerCode: "Not Supported",
    Extension: ".pp",
  },
  {
    LanguageName: "Python 2",
    LanguageCode: "python",
    CompilerCode: "python2",
    Extension: ".py",
  },
  {
    LanguageName: "Python 3",
    LanguageCode: "python",
    CompilerCode: "python3",
    Extension: ".py",
  },
  {
    LanguageName: "QML",
    LanguageCode: "qml",
    CompilerCode: "Not Supported",
    Extension: ".qml",
  },
  { LanguageName: "R", LanguageCode: "r", CompilerCode: "r", Extension: ".r" },
  {
    LanguageName: "Racket",
    LanguageCode: "racket",
    CompilerCode: "racket",
    Extension: ".rkt",
  },
  {
    LanguageName: "Restructed Text",
    LanguageCode: "restructuredtext",
    CompilerCode: "Not Supported",
    Extension: ".rst",
  },
  {
    LanguageName: "REST",
    LanguageCode: "rest",
    CompilerCode: "Not Supported",
    Extension: ".rst",
  },
  {
    LanguageName: "Ruby",
    LanguageCode: "ruby",
    CompilerCode: "ruby",
    Extension: ".rb",
  },
  {
    LanguageName: "Rust",
    LanguageCode: "rust",
    CompilerCode: "rust",
    Extension: ".rs",
  },
  {
    LanguageName: "SASS",
    LanguageCode: "sass",
    CompilerCode: "Not Supported",
    Extension: ".sass",
  },
  {
    LanguageName: "Less",
    LanguageCode: "less",
    CompilerCode: "Not Supported",
    Extension: ".less",
  },
  {
    LanguageName: "Scala",
    LanguageCode: "scala",
    CompilerCode: "scala",
    Extension: ".scala",
  },
  {
    LanguageName: "Scheme",
    LanguageCode: "scheme",
    CompilerCode: "scheme",
    Extension: ".scm",
  },
  {
    LanguageName: "Shell",
    LanguageCode: "shell",
    CompilerCode: "Not Supported",
    Extension: ".sh",
  },
  {
    LanguageName: "Small Talk",
    LanguageCode: "smalltalk",
    CompilerCode: "Not Supported",
    Extension: ".st",
  },
  {
    LanguageName: "SQL",
    LanguageCode: "sql",
    CompilerCode: "sql",
    Extension: ".sql",
  },
  {
    LanguageName: "Standard ML",
    LanguageCode: "standardml",
    CompilerCode: "Not Supported",
    Extension: ".sml",
  },
  {
    LanguageName: "SML",
    LanguageCode: "sml",
    CompilerCode: "Not Supported",
    Extension: ".sml",
  },
  {
    LanguageName: "SWIFT",
    LanguageCode: "swift",
    CompilerCode: "swift",
    Extension: ".swift",
  },
  {
    LanguageName: "TCL",
    LanguageCode: "tcl",
    CompilerCode: "tcl",
    Extension: ".tcl",
  },
  {
    LanguageName: "Tex",
    LanguageCode: "tex",
    CompilerCode: "Not Supported",
    Extension: ".tex",
  },
  {
    LanguageName: "Text",
    LanguageCode: "text",
    CompilerCode: "Not Supported",
    Extension: ".txt",
  },
  {
    LanguageName: "TSX",
    LanguageCode: "tsx",
    CompilerCode: "Not Supported",
    Extension: ".tsx",
  },
  {
    LanguageName: "TS",
    LanguageCode: "ts",
    CompilerCode: "Not Supported",
    Extension: ".ts",
  },
  {
    LanguageName: "TypeScript",
    LanguageCode: "typescript",
    CompilerCode: "Not Supported",
    Extension: ".ts",
  },
  {
    LanguageName: "Vala",
    LanguageCode: "vala",
    CompilerCode: "Not Supported",
    Extension: ".vala",
  },
  {
    LanguageName: "VB.NET",
    LanguageCode: "vbnet",
    CompilerCode: "vbn",
    Extension: ".vb",
  },
  {
    LanguageName: "Verilog",
    LanguageCode: "verilog",
    CompilerCode: "verilog",
    Extension: ".v",
  },
  {
    LanguageName: "VDHL",
    LanguageCode: "vhdl",
    CompilerCode: "Not Supported",
    Extension: ".vhdl",
  },
  {
    LanguageName: "XML",
    LanguageCode: "xml",
    CompilerCode: "Not Supported",
    Extension: ".xml",
  },
  {
    LanguageName: "XQuery",
    LanguageCode: "xquery",
    CompilerCode: "Not Supported",
    Extension: ".xq",
  },
  {
    LanguageName: "YAML",
    LanguageCode: "yaml",
    CompilerCode: "Not Supported",
    Extension: ".yaml",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function CodeLanguageList(props) {
  //To select multiple you have to map them in an array
  const [selected, setSelected] = useState({ LanguageName: "Select Language" });
  useEffect(() => {
    if (selected.LanguageName !== "Select Language") {
      props.getLanguage(selected);
    }
  }, [selected]);

  return (
    <Listbox value={selected} onChange={setSelected}>
      {({ open }) => (
        <>
          <div className="mt-1 relative">
            <Listbox.Button className="relative w-full bg-palette_color2 text-secondary  font-robo border-[1px] border-palette_color1 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none sm:text-sm">
              <span className="ml-3 block truncate">
                {selected.LanguageName}
              </span>

              <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="h-5 w-5 text-primary"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 w-full bg-palette_color2 shadow-md shadow-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                {languages.map((language) => (
                  <Listbox.Option
                    key={language.LanguageName}
                    className={({ active }) =>
                      classNames(
                        active
                          ? "text-palette_color2 bg-palette_color1"
                          : "text-palette_color1",
                        "cursor-default select-none relative py-2 pl-3 pr-9 font-robo "
                      )
                    }
                    value={language}
                  >
                    {({ selected, active }) => (
                      <>
                        <div className="flex items-center">
                          <span
                            className={classNames(
                              selected ? "font-semibold" : "font-normal",
                              "ml-3 block truncate"
                            )}
                          >
                            {language.LanguageName}
                          </span>
                        </div>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? "text-primary" : "text-palette_color4",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}

export default CodeLanguageList;
export { languages };
export const isExtensionCodeFile = (extension) => {
  const found = languages.find(
    (language) => language.Extension === "." + extension
  );

  if (found) {
    return true;
  } else {
    return false;
  }
};
export const getCompilerCodeByExtension = (extension) => {
  const found = languages.find(
    (language) => language.Extension === "." + extension
  );

  return found;
};
export const urlToBlob = async (url) => {
  return fetch(url).then((response) => response.blob());
};
export const blobToString = async (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(blob);
  });
};
